export class Reference {
	constructor(
		public packageSize: number | null,
		public referenceBasketVersion: string,
		public historicProductDataViewDate: Date | null,
		public referencedProductType: string | null,
		public dosageStrength: number | null
	) {}
}
